export const GET_LANDMARK_LIST = 'GET_LANDMARK_LIST';
export const GET_LANDMARK_LIST_SUCCESS = 'GET_LANDMARK_LIST_SUCCESS';
export const GET_LANDMARK_LIST_FAILED = 'GET_LANDMARK_LIST_FAILED';
export const GET_LANDMARK_DETAILS = 'GET_LANDMARK_DETAILS';
export const GET_LANDMARK_DETAILS_SUCCESS = 'GET_LANDMARK_DETAILS_SUCCESS';
export const GET_LANDMARK_DETAILS_FAILED = 'GET_LANDMARK_DETAILS_FAILED';
export const CREATE_LANDMARK = 'CREATE_LANDMARK';
export const CREATE_LANDMARK_SUCCESS = 'CREATE_LANDMARK_SUCCESS';
export const CREATE_LANDMARK_FAILED = 'CREATE_LANDMARK_FAILED';
export const UPDATE_LANDMARK = 'UPDATE_LANDMARK';
export const UPDATE_LANDMARK_SUCCESS = 'UPDATE_LANDMARK_SUCCESS';
export const UPDATE_LANDMARK_FAILED = 'UPDATE_LANDMARK_FAILED';
export const DELETE_LANDMARK = 'DELETE_LANDMARK';
export const DELETE_LANDMARK_SUCCESS = 'DELETE_LANDMARK_SUCCESS';
export const DELETE_LANDMARK_FAILED = 'DELETE_LANDMARK_FAILED';
export const CLEAR_LANDMARK_LIST = 'CLEAR_LANDMARK_LIST';
